import React from 'react';
import styled from 'styled-components';
import { StripeProvider, Elements } from 'react-stripe-elements';

import CardForm from './CardForm';
import { STRIPE_PUBLIC_KEY } from '../../services/constants';
import BillingWindow from '../Wrappers/BillingWindow';

const CCtitle = styled.div`
  font-family: BrandonGrotesque-Regular;
  text-align: center;
  font-size: 16px;
  color: #555555;
  margin-bottom: 50px;
`;

const Container = styled.div`
  text-align: center;
  margin: auto;
`;

function AddCard(props: { desktop: boolean }) {
  return (
    <BillingWindow desktop={props.desktop} page="card">
      {props.desktop ? (
        <Container>
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="207"
            height="155"
            viewBox="0 0 207 155"
            style={{ width: '150px' }}
          >
            <g fill="none" fillRule="evenodd" stroke="#333333" strokeWidth="2">
              <rect width="205" height="152.485" x="1" y="1" rx="3" />
              <path d="M4.814 38.621h200.23M4.814 67.587h200.23M117.942 96.553h52.953M142.012 125.52h28.883" />
            </g>
          </svg>
        </Container>
      ) : (
        <></>
      )}
      <StripeProvider apiKey={STRIPE_PUBLIC_KEY}>
        <div style={{ paddingTop: '0px' }}>
          <CCtitle>Add a new card by entering the details below.</CCtitle>
          <Elements>
            <CardForm desktop={props.desktop} />
          </Elements>
        </div>
      </StripeProvider>
    </BillingWindow>
  );
}
export default AddCard;
